import { Button, ChakraProps, Icon, Tooltip } from '@chakra-ui/react';
import { IconType } from 'react-icons';

export interface PageHeaderActionProps {
  label: string;
  primary?: boolean;
  disruptive?: boolean;
  icon?: IconType;
  action: (() => void) | undefined;
  tooltip?: string;
  style?: ChakraProps['sx'];
}

const PageHeaderAction: React.FC<PageHeaderActionProps> = ({
  label,
  primary = false,
  disruptive = false,
  icon,
  action,
  tooltip,
  style
}) => {
  const outlined = !primary && !disruptive;
  const variant = outlined ? 'outline' : disruptive ? 'danger' : 'primary';

  const button = (
    <Button
      sx={style}
      ml={{ base: 4, lg: 6 }}
      mb={4}
      minW="110px"
      colorScheme={outlined ? 'gray' : undefined}
      isDisabled={typeof action === 'undefined'}
      onClick={action}
      variant={variant}
      fontWeight={!outlined ? '500' : '400'}
      fontSize={16}
      leftIcon={
        icon && (
          <Icon as={icon} fontSize="18px" color={outlined ? 'gray.400' : undefined} mr="2px" />
        )
      }
    >
      {label}
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default PageHeaderAction;
